export default __webpack_public_path__ + "images/d432c01df862dd96c20da56fbbecc958.svg";